
define('ldsh!modules/accounts/companies/list/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="messages-container"></div>\n';
 if (companies.isRequest) {;
__p += '\n      <div class="spinner__container">\n        <i class="ri-loader-4-fill fa-spin"></i>\n      </div>\n\n';
 } else { ;
__p += '\n\n<div class="row">\n  <div class="col-md-9">\n    <p><strong class="i18n size20" data-i18n="ACCOUNTS.COMPANIES.LBL_TITLE"></strong></p>\n    <p class="i18n" data-i18n="ACCOUNTS.COMPANIES.LBL_SUBTITLE">Estos son las subcuentas que has creado en MDirector.</p>\n  </div>\n  <div class="col-md-3">\n    <a id="createNewAcccount" data-groupId="' +
__e(groupId) +
'" class="pull-right btn boton-principal i18n" data-i18n="ACCOUNTS.COMPANIES.LBL_NEW_COMPANY"  role="button">Crear subcuenta</a>\n  </div>\n</div>\n\n<div class="row">\n    <div class="col-md-12">\n        ';
 _.each(companies.models,function(company) { ;
__p += '\n            ';
 if(company.get("status")==1){ ;
__p += '\n                <div id="company-' +
__e(company.get("id")) +
'" class="panel panel-default">\n                  <fieldset>\n                    <div class="col-md-12">\n                        <div class="nombre flex align-flex-start justify-space-between mb12">\n                          <span id="name-emp-' +
__e(company.get("id")) +
'" class="size20" style="margin-right: 10px;">' +
__e(company.get("name")) +
' (' +
__e(company.get("id")) +
')</span>\n                          <div class="flex align-center gap-12">\n                            <a\n                              id="popover-signup-' +
__e(company.get("id")) +
'"\n                              class="btn--rounded cambiarnombre i18n"\n                              data-i18n="[title]ACCOUNTS.COMPANIES.LBL_DELETE_COMPANY_LIST"\n                              href="javascript: void(0)"\n                              data-emp_id="' +
__e(company.get("id")) +
'"\n                            >\n                              <i class="ri-delete-bin-line"></i>\n                            </a>\n                            <a\n                              href="/accounts/company/' +
__e(company.get("id")) +
'/group/' +
__e(groupId) +
'"\n                              class="btn--rounded cambiarnombre i18n"\n                              data-i18n="[title]ACCOUNTS.COMPANIES.LBL_EDIT_COMPANY"\n                              data-emp_id="' +
__e(company.get("id")) +
'"\n                            >\n                              <i class="ri-edit-line"></i>\n                            </a>\n                          </div>\n                        </div>\n                        <div class="servicios">\n                            ';
 var count_services = 0; ;
__p += '\n                                ';
 _.each(company.get("services"),function(service) { ;
__p += '\n                                     ';
 if(group.hasService(service.name) && service.active ==1){;
__p += '\n                                       ';
 if(count_services !=0){;
__p += '\n                                           /\n                                        ';
 } ;
__p += '\n                                       <strong class=" naranja i18n" data-i18n="ACCOUNTS.COMPANIES.LBL_SERVICE_' +
__e(service.service_id) +
'"> ' +
__e(service.name) +
'</strong>\n                                     ';
 count_services++; ;
__p += '\n                                     ';
 } ;
__p += '\n                                 ';
 }); ;
__p += '\n                         </div>\n                    </div>\n                  </fieldset>\n                </div>\n            ';
 } ;
__p += '\n        ';
 }); ;
__p += '\n    </div>\n</div>\n\n';
 } ;
__p += '\n\n\n<div id=\'renderModalServices\'></div>\n';

}
return __p
};});

